import React from "react";
import { MapPin } from "lucide-react";

export default function Footer({ lastUpdated, footerColor }) {
  const currentYear = new Date().getFullYear();
  const bg = footerColor || "#1a1a1a";
  return (
    <footer className="py-6 px-6" style={{ backgroundColor: bg }}>
      <div className="flex flex-col items-center gap-1 text-center">
        <img
          src="https://media.base44.com/images/public/6a3e1c26ec9e714e5b52016b/fe145ba3d_SELISE_digital_platforms_white.svg"
          alt="SELISE digital platforms"
          className="h-16 w-auto pt-6 mb-6"
        />
        <p className="flex items-center justify-center gap-1.5 text-xs text-[#b3b3b3]">
          <MapPin className="w-3.5 h-3.5 flex-shrink-0" />
          The Circle 37, 8058 Zürich-Flughafen, Zürich, Switzerland.
        </p>
        <p className="text-xs text-[#b3b3b3]">© {currentYear} SELISE Group. All Rights Reserved.</p>
        <p className="text-xs text-[#b3b3b3]">
          Last updated: {lastUpdated ? new Date(lastUpdated).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }) : "—"}
        </p>
      </div>
    </footer>
  );
}